import React from 'react';
import { Box, MenuItem, Select } from '@mui/material';
import { PRES, TYPE } from '../chrome';
import {
  SIMPLE_FONTS,
  SimpleFont,
  matchSimpleFont,
  resolveSlideFontFamily,
} from '../types';
import { usePresentationSettings } from '../PresentationSettingsContext';
import { visibleSimpleFonts } from '../presentationSettings';

interface TypefaceSelectProps {
  style?: { fontFamily?: string; fontWeight?: number | string };
  mixed?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  onChange: (font: SimpleFont) => void;
}

const TypefaceSelect: React.FC<TypefaceSelectProps> = ({
  style,
  mixed,
  disabled,
  fullWidth,
  onChange,
}) => {
  const { settings } = usePresentationSettings();
  const matched = mixed ? null : matchSimpleFont(style);
  const fonts = visibleSimpleFonts(settings, matched?.id);
  return (
    <Select
      size="small"
      displayEmpty
      disabled={disabled}
      title="Typsnitt"
      value={matched?.id || ''}
      onMouseDown={(event) => event.stopPropagation()}
      onChange={(event) => {
        const font = SIMPLE_FONTS.find((item) => item.id === event.target.value);
        if (font) onChange(font);
      }}
      renderValue={() => {
        if (mixed) return 'Blandat';
        return fonts.find((font) => font.id === matched?.id)?.label || matched?.label || 'Typsnitt';
      }}
      sx={{
        minWidth: fullWidth ? undefined : 228,
        width: fullWidth ? '100%' : undefined,
        flexShrink: 0,
        color: PRES.textPrimary,
        bgcolor: PRES.white,
        borderRadius: 1.5,
        fontFamily: TYPE.ui,
        fontSize: 12,
        '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(10,39,87,0.12)' },
        '& .MuiSelect-select': {
          py: 0.55,
          px: 1.1,
          fontFamily: TYPE.ui,
          fontWeight: 500,
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: { maxHeight: 320 },
        },
      }}
    >
      <MenuItem value="" sx={{ display: 'none' }} />
      {fonts.map((font) => (
        <MenuItem
          key={font.id}
          value={font.id}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2,
            fontFamily: TYPE.ui,
            fontWeight: 500,
            fontSize: 13,
            color: PRES.textPrimary,
          }}
        >
          <Box component="span">{font.label}</Box>
          <Box
            component="span"
            aria-hidden
            sx={{
              minWidth: 36,
              textAlign: 'right',
              fontFamily: resolveSlideFontFamily(font.family),
              fontWeight: font.fontWeight,
              fontSize: 16,
              lineHeight: 1,
              color: PRES.textSecondary,
            }}
          >
            Aa
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default TypefaceSelect;
